import React, { useCallback, useEffect, useRef, useState } from 'react'
import { IonContent, IonPage, IonHeader } from '@ionic/react'
import { connectSlotsGamesLobby } from './SlotsGamesLobby.connect'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'

import './SlotsGamesLobby.scss'
import Toolbar from '../../components/Toolbar/Toolbar'
// import WhiteArrow from '../../assets/images/slotsGames/Arrow.svg'
// import SearchIcon from '../../assets/images/searchIconDeskWhite.svg'
import JiliPopUp from '../../components/SlotsJiliPopUp'
// import chip from './chip.png'
// import slotsBackgroundEl from './slotsBackgroundEl.png'
// import slotsRouletteIn from './slotsRouletteIn.png'
// import slotsRouletteOut from './slotsRouletteOut.png'
// import slotMachine from './slotMachine.png'
import FooterDesktop from '../../components/FooterDesktop/FooterDesktop'
// import SlotsCasinoPopUp from '../../components/SlotsCasinoPopup'
import ChevronCompactRight from './chevron-compact-right.svg'
import ChevronCompactLeft from './chevron-compact-left.svg'
import slotBanner from './slot-banner.webp'

/**
 * Gets the thumbnail image URL for a provider logo
 * @param {string} code - The provider code
 * @param {'cl'|'bw'} colorOrBlacnAndWhite - Whether to get color ('cl') or black and white ('bw') version
 * @param {'dark'|'light'} lightOrDark - Whether to get dark or light version
 * @returns {string} The URL for the provider logo image
 */
export const getThumbnailImageOfProvider = (
  code,
  colorOrBlacnAndWhite = 'cl',
  lightOrDark = 'light'
) => {
  const URL = `https://luckmedia.link/providers/${code}/logo_3_2_${colorOrBlacnAndWhite}_${lightOrDark}.svg`
  return URL
}

const SlotsGamesLobby = ({
  inplayPopular,
  actions,
  slotsGames,
  slotsGamesSearch,
  auth,
  elementsParams,
  quickButtonSlots,
  slotCasinoPopUp,
}) => {
  const [jiliGame, setJiliGame] = useState()
  const [searchOn, setSearchOn] = useState(false)
  const width =
    elementsParams && elementsParams?.clientWidth
      ? elementsParams?.clientWidth
      : window.innerWidth.clientWidth
  const history = useHistory()

  const isPopUpOpen = useSelector((state) => state.slotsPopUp.isPopUpOpen)

  const slotsGamesProvider = useSelector(
    (state) => state.slotsGames.slotsGamesProvider
  )

  const allGamesProviderWise = useSelector(
    (state) => state.slotsGames.allGamesProviderWise
  )

  // Add refs object to store multiple refs
  const providerRefs = useRef({})
  const [selectedProvider, setSelectedProvider] = useState(null)

  useEffect(() => {
    actions.requestSlotGamesProvider(0)
  }, [])

  // First useEffect to set initial selected provider when list loads
  useEffect(() => {
    if (slotsGamesProvider?.length) {
      // console.log('Setting initial provider:', slotsGamesProvider[0])
      setSelectedProvider(slotsGamesProvider[0])
    }
  }, [slotsGamesProvider])

  // Second useEffect to make the provider-specific call
  useEffect(() => {
    if (selectedProvider && selectedProvider._id) {
      // Check for _id instead of id
      // console.log('Making provider-specific call with:', selectedProvider)
      actions.requestSlotGamesProvider(
        selectedProvider._id, // Use _id instead of id based on your handleClick
        selectedProvider.name
      )
    }
  }, [selectedProvider])

  const onOpenGame = useCallback(
    (item) => {
      if (auth) {
        actions.requestSlotsGamesID(item?.id, 'CASINO_2')
        history.push(`/live_casino_slot/${item?.id}`)
      } else {
        actions.setLoginNew(true)
      }
    },
    [auth]
  )

  // Update the handleClick function
  const handleClick = useCallback((gameDetails) => {
    // scrollToProvider(gameDetails.name)
    actions.requestSlotGamesProvider(gameDetails?._id, gameDetails?.name)
    setSelectedProvider(gameDetails)
    // console.log('gameDetails', gameDetails)
  }, [])

  const scrollContainerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  // Add scroll handler function
  const handleScroll = (direction) => {
    if (!scrollContainerRef.current) return;
    
    const container = scrollContainerRef.current;
    const scrollAmount = 200; // Adjust this value to control scroll distance
    
    if (direction === 'right') {
      container.scrollLeft += scrollAmount;
    } else {
      container.scrollLeft -= scrollAmount;
    }
    
    // Update scroll buttons visibility
    setTimeout(() => {
      setCanScrollLeft(container.scrollLeft > 0);
      setCanScrollRight(
        container.scrollLeft < container.scrollWidth - container.clientWidth
      );
    }, 100);
  };

  // Add scroll check on mount and resize
  useEffect(() => {
    const checkScroll = () => {
      if (!scrollContainerRef.current) return;
      const container = scrollContainerRef.current;
      setCanScrollRight(
        container.scrollLeft < container.scrollWidth - container.clientWidth
      );
    };

    checkScroll();
    window.addEventListener('resize', checkScroll);
    return () => window.removeEventListener('resize', checkScroll);
  }, []);

  return (
    <IonPage>
      {width < 1024 ? (
        <IonHeader>
          <Toolbar />
        </IonHeader>
      ) : (
        <></>
      )}
      {isPopUpOpen ? <JiliPopUp item={jiliGame} /> : null}
      <IonContent>

        <div
          className="bgSlots"
          style={width < 1024 ? { marginTop: '0px' } : {}}
        >
        <div className="slot-banner">
          <img src={slotBanner} alt="slot-banner" />
        </div>
          <div
            className="Slots-header"
            style={width < 1024 ? { position: 'relative' } : {}}
          >
            <div className={`scroll-arrow left ${!canScrollLeft ? 'disabled' : ''}`} onClick={() => handleScroll('left')}>
              <img src={ChevronCompactLeft} alt="left" />
            </div>
            <div className="Slots-header__filter">
              <div className="Slots-header__filter-row" ref={scrollContainerRef}>
                {slotsGamesProvider?.length > 0 &&
                  slotsGamesProvider?.map((item, index) => {
                    return (
                      <div
                        className="Slots-header__filter-row-item"
                        onClick={() => handleClick(item)}
                        key={index}
                      >
                        <img
                          src={getThumbnailImageOfProvider(
                            item?.code,
                            'cl',
                            'dark'
                          )}
                          alt={item?.name}
                        />
                      </div>
                    )
                  })}
              </div>
            </div>
            <div className={`scroll-arrow right ${!canScrollRight ? 'disabled' : ''}`} onClick={() => handleScroll('right')}>
              <img src={ChevronCompactRight} alt="right" />
            </div>
          </div>

          <div className={`Slots-content`}>
            <div className="Slots-content__menu">
              <div className="Slots-content__menu-games">
                <div className="Slots-content__menu-games__allgames">
                  {/* {allGamesProviderWise &&
                    allGamesProviderWise?.map((item, index) => {
                      return ( */}
                  <React.Fragment>
                    {/* <div className="Slots-content__menu-games__allgames-title">
                      <span
                        className="Slots-content__menu-games__allgames-title-ref"
                        id={selectedProvider?.providerName}
                      ></span>
                      <div className="Slots-content__menu-games__allgames-title-name">
                        {selectedProvider?.providerName}
                      </div>
                    </div> */}
                    <div style={{ width: '100%' }}>
                      <div className="mainProviderGames">
                        {allGamesProviderWise?.map((providerGame, index) => {
                          if (providerGame == undefined) return null
                          return (
                            <div
                              className="mainProviderGames-item"
                              onClick={() => onOpenGame(providerGame)}
                              key={index}
                            >
                              <img
                                src={`https://luckmedia.link/${providerGame?.id}/thumb_3_4_custom.webp`}
                                alt={providerGame?.trans?.en}
                              />
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  </React.Fragment>
                  {/* )
                    })} */}
                </div>
              </div>
            </div>
            {/* <div style={{marginTop: '100px'}}> */}
            {width > 1024 && <FooterDesktop />}
            {/* </div> */}
          </div>
        </div>
        {/*{width < 1024 && <FooterDesktop />}*/}
      </IonContent>
    </IonPage>
  )
}

export default connectSlotsGamesLobby()(SlotsGamesLobby)
